import { render, staticRenderFns } from "./allDataPageList.vue?vue&type=template&id=b78c5078"
import script from "./allDataPageList.vue?vue&type=script&lang=js"
export * from "./allDataPageList.vue?vue&type=script&lang=js"
import style0 from "./allDataPageList.vue?vue&type=style&index=0&id=b78c5078&prod&lang=css"
import style1 from "./allDataPageList.vue?vue&type=style&index=1&id=b78c5078&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports